export default __webpack_public_path__ + "static/media/budget-icon.ddda0297.svg";